<template>
  <div class="markup-quiz">
    <div v-for="(question, index) in questions" :key="`quiz-${index}`">
      <question :question="question" />
    </div>
  </div>
</template>
<script>
import Question from "./question"
export default {
  components: {
    Question
  },
  props: {
    questions: {
      type: Array,
      required: true
    }
  }
}
</script>
